import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Column = _resolveComponent("Column")
  const _component_Button = _resolveComponent("Button")
  const _component_DataTable = _resolveComponent("DataTable")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_component_DataTable, {
    value: _ctx.schedulations,
    id: "schedulations-table",
    class: "p-datatable-sm kn-table",
    dataKey: "triggerName",
    paginator: true,
    rows: 20,
    responsiveLayout: "stack",
    breakpoint: "960px"
  }, {
    empty: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Column, {
        headerStyle: _ctx.workspaceSchedulationSchedulationsTableDescriptor.checkboxColumn.style
      }, {
        body: _withCtx((slotProps) => [
          _createVNode(_component_Checkbox, {
            name: _ctx.index + '',
            modelValue: _ctx.selectedSchedulations,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedSchedulations = $event)),
            value: slotProps.data,
            onChange: _ctx.setSelectedSchedulations
          }, null, 8, ["name", "modelValue", "value", "onChange"])
        ]),
        _: 1
      }, 8, ["headerStyle"]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.workspaceSchedulationSchedulationsTableDescriptor.columns, (col) => {
        return (_openBlock(), _createBlock(_component_Column, {
          class: "kn-truncated",
          field: col.field,
          header: _ctx.$t(col.header),
          key: col.field,
          sortable: true
        }, null, 8, ["field", "header"]))
      }), 128)),
      _createVNode(_component_Column, {
        style: _ctx.workspaceSchedulationSchedulationsTableDescriptor.iconColumn.style
      }, {
        body: _withCtx((slotProps) => [
          (_ctx.canRunScheduledExecutions)
            ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                key: 0,
                icon: "fa fa-play-circle",
                class: "p-button-link",
                onClick: _withModifiers(($event: any) => (_ctx.runSchedulation(slotProps.data)), ["stop"])
              }, null, 8, ["onClick"])), [
                [
                  _directive_tooltip,
                  _ctx.$t('common.run'),
                  void 0,
                  { top: true }
                ]
              ])
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    _: 1
  }, 8, ["value"]))
}